function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 43.5,
  cy: 43.5,
  r: 43.5,
  fill: "#DF4F5F"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.722 29.887c-.15.163-.312.354-.488.53-4.17 4.172-8.33 8.352-12.521 12.503-.508.503-.575.758-.024 1.303 4.198 4.144 8.348 8.335 12.539 12.485.499.493.511.756 0 1.248a240.536 240.536 0 00-5.509 5.506c-.46.476-.713.48-1.186.003-4.172-4.21-8.38-8.382-12.547-12.596-.511-.516-.757-.467-1.241.019-4.13 4.172-8.3 8.305-12.43 12.475-.512.518-.805.628-1.371.034a159.221 159.221 0 00-5.388-5.388c-.592-.564-.488-.855.032-1.37 4.17-4.132 8.303-8.3 12.475-12.431.483-.48.543-.728.023-1.241-4.214-4.168-8.388-8.376-12.596-12.547-.464-.463-.494-.716-.008-1.187a232.334 232.334 0 005.506-5.508c.486-.503.747-.516 1.248-.01 4.15 4.19 8.341 8.34 12.488 12.536.524.53.778.53 1.302 0 4.128-4.174 8.301-8.304 12.424-12.48.567-.573.853-.511 1.371.026 1.804 1.867 3.66 3.681 5.494 5.521.153.155.363.274.41.571l-.003-.002z",
  fill: "#FEFEFE"
});

function SvgFailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgFailIcon;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/failIcon.svg
// module id = 1317
// module chunks = 10